import { render, staticRenderFns } from "./ProjectVersions.vue?vue&type=template&id=70c4ff23&scoped=true&"
import script from "./ProjectVersions.vue?vue&type=script&lang=js&"
export * from "./ProjectVersions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersions.vue?vue&type=style&index=0&id=70c4ff23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4ff23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VLayout,VSpacer,VTooltip})
